import { useParams } from "react-router-dom";
import PhotoContent from "./PhotoContent";

export default function PhotoPage() {
  const { id } = useParams();

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Photo Page</h1>
      <PhotoContent photoId={id!} />
    </div>
  );
}

